import {createContext} from 'react'

type FeaturesContextProps = {
  shouldDisplayAnnouncementBanner: boolean
  shouldDisplayOldLoginFlow: boolean
  shouldDisplayRequestAccessForm: boolean
}
export const FeaturesContext = createContext<FeaturesContextProps | undefined>(undefined)
